import { render, staticRenderFns } from "./OperationEditTab.vue?vue&type=template&id=5b66a3e2"
import script from "./OperationEditTab.vue?vue&type=script&lang=js"
export * from "./OperationEditTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports